import React from 'react'
import { Typography } from 'antd'
import { CustomNextLink } from 'src/components'
import styles from './AuthMainText.module.scss'

interface AuthMainTextProps {
  mainText: string,
  secondLabel?: string,
  linkLabel?: string,
  link?: string,
  showDownLabel?: boolean
}

const AuthMainText: React.FC<AuthMainTextProps> = (props) => {
  const { mainText, secondLabel, linkLabel, link, showDownLabel = true } = props

  return <div className='centered-div'>
    <div className={styles['content']}>
      <Typography.Title className={styles.title}>{mainText}</Typography.Title>
      {showDownLabel && <>
        <Typography.Title className={styles.subtitle} level={4}>
          {secondLabel}
          <CustomNextLink
            route={link || ''}
            label={linkLabel}
          />
        </Typography.Title>
      </>}
    </div>
  </div>
}

export default AuthMainText
